/**
 * Feature flags derived from current user profile / env.
 */

/**
 * @deprecated Digital content is available to all users. Kept for temporary
 * compatibility; always returns true. Prefer removing call sites.
 * @param {Object} [_currentUser]
 * @returns {boolean}
 */
export const hasFeatContentEnabled = () => true;

/** @deprecated No longer used as a privateData gate. */
export const FEAT_CONTENT_PRIVATE_FIELD = 'featContent';

/**
 * Practitioner marketing campaigns. CRA/webpack inlines `process.env.REACT_APP_*`
 * as string literals at build time, so that access must stay a static member
 * expression. Off unless the value is the exact string "true".
 */
export const REACT_APP_FEATURE_MARKETING_CAMPAIGNS = 'REACT_APP_FEATURE_MARKETING_CAMPAIGNS';

export const isMarketingCampaignsEnabled = env => {
  const value = env
    ? env.REACT_APP_FEATURE_MARKETING_CAMPAIGNS
    : process.env.REACT_APP_FEATURE_MARKETING_CAMPAIGNS;
  return value === 'true';
};
